module.exports = __webpack_public_path__ + "assets/img/37_1480.00d99ae6.jpg";